import { OrganizationStudents } from "@/pages/organisaties/cursisten/OrganizationStudents"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/cursisten/",
)({
  component: OrganizationOverview,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function OrganizationOverview() {
  return <OrganizationStudents />
}
